import React from 'react';

import { flagStyles } from '../settings';

const SvgSZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5064px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSZ;
